function InsurerBillingDataMeedyVO(idBillingData, billingType, flatRate, priceForInsured, numberOfInsured, useAmountForVisit, amountForVisit, usePercentForVisit,
                              percentForVisit, regon, nip, accountNumber, contractNumber, contractSigningDate, contractTerminationDate, invoicePeriod, lastInvoiceDate, invoiceNumber, invoiceNumberSuffix, vatRate) {

    this.idBillingData = idBillingData;
    this.billingType = billingType;
    this.flatRate = flatRate === true;
    this.priceForInsured = priceForInsured;
    this.numberOfInsured = numberOfInsured;
    this.useAmountForVisit = useAmountForVisit === true;
    this.amountForVisit = amountForVisit;
    this.usePercentForVisit = usePercentForVisit === true;
    this.percentForVisit = percentForVisit;
    this.regon = regon;
    this.nip = nip;
    this.accountNumber = accountNumber;
    this.contractNumber = contractNumber;
    this.contractSigningDate = contractSigningDate;
    this.contractTerminationDate = contractTerminationDate;
    this.invoicePeriod = invoicePeriod;
    this.lastInvoiceDate = lastInvoiceDate;
    this.invoiceNumber = invoiceNumber;
    this.invoiceNumberSuffix = invoiceNumberSuffix;
    this.vatRate = vatRate;

    var _typeContext = {
        contractSigningDate : Date,
        contractTerminationDate : Date,
        lastInvoiceDate : Date
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
